import React, { useContext, useState, useEffect } from "react"
import { auth } from "./Firebase"

const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext)
}
export function resetPassword(email) {
    return auth.sendPasswordResetEmail(email)
}


export function AuthProvider({ children, authVal }) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(true)

    function signup(email, password) {
        return auth.createUserWithEmailAndPassword(email, password)
    }

    function resetPassword(email) {
        return auth.sendPasswordResetEmail(email)
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user)
            setLoading(false)
        })
        return unsubscribe
    }, [])

    const value = {
        currentUser,
        signup,
        auth,
        resetPassword
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}
